module.exports = __webpack_public_path__ + "media/images/illustrations/wave-starworks-1-d7276b2fa29cff5d70e02c27cf1b32a4.svg";